import { useState, useEffect } from 'react'
import { authService } from '@/services/auth'
import toast from 'react-hot-toast'

export const GoogleLoginButton = () => {
  const [oauth2Disponivel, setOauth2Disponivel] = useState(false)
  const [carregando, setCarregando] = useState(false)
  const [verificando, setVerificando] = useState(true)

  useEffect(() => {
    // Verificar se OAuth2 está disponível ao carregar componente
    verificarOAuth2Status()
  }, [])

  const verificarOAuth2Status = async () => {
    try {
      setVerificando(true)
      const status = await authService.verificarOAuth2Status()
      setOauth2Disponivel(status.oauth2_habilitado && status.google_configurado)
    } catch (error) {
      console.error('Erro ao verificar status OAuth2:', error)
      setOauth2Disponivel(false)
    } finally {
      setVerificando(false)
    }
  }

  const handleGoogleLogin = () => {
    if (!oauth2Disponivel) {
      toast.error('Login com Google não está disponível no momento.')
      return
    }

    setCarregando(true)
    
    try {
      // Redirecionar para login Google
      const url = authService.obterUrlLoginGoogle()
      window.location.href = url
    } catch (error) {
      console.error('Erro ao iniciar login Google:', error)
      toast.error('Erro ao iniciar login com Google. Tente novamente.')
      setCarregando(false)
    }
  }

  // Não mostrar o botão se ainda estiver verificando ou se não estiver disponível
  if (verificando || !oauth2Disponivel) {
    return null
  }

  return (
    <button
      onClick={handleGoogleLogin}
      disabled={carregando}
      className="google-login-button"
      type="button"
    >
      <svg
        className="google-icon"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path
            d="M17.64 9.204c0-.636-.057-1.272-.164-1.873H9v3.544h4.844c-.209 1.118-.824 2.097-1.757 2.886v2.217h2.843c1.687-1.604 2.657-3.971 2.657-6.764z"
            fill="#4285F4"
          />
          <path
            d="M9 18c2.43 0 4.467-.808 5.965-2.186l-2.843-2.217c-.761.52-1.735.838-3.122.838-2.246 0-4.152-1.519-4.834-3.545H1.134v2.285C2.961 15.52 5.942 18 9 18z"
            fill="#34A853"
          />
          <path
            d="M4.166 10.714c-.174-.524-.274-1.084-.274-1.714s.1-1.19.274-1.715L4.116 4.99H1.134C.457 6.18 0 7.53 0 9s.457 2.82 1.134 4.01l2.844-2.285z"
            fill="#FBBC04"
          />
          <path
            d="M9 3.576c1.294 0 2.454.442 3.347 1.194l2.518-2.518C13.467.93 11.43 0 9 0 5.942 0 2.961 2.48 1.134 4.99l2.832 2.285C4.848 5.095 6.754 3.576 9 3.576z"
            fill="#EA4335"
          />
        </g>
      </svg>
      {carregando ? 'Carregando...' : 'Entrar com Google'}
    </button>
  )
}

